import Current from './components/Current';
import Search from './components/Search';
import './App.css';

function App() {
  return (
    <div className="App">
        <Search />
        <Current />
    </div>
  );
}

export default App;
